import { createBrowserRouter } from "react-router-dom";
import DashboardLayout from "../layout/DashboardLayout";
import Main from "../layout/Main";
import Appointment from "../pages/appointment/Appointment/Appointment";
import AddDoctor from "../pages/Dashboard/AddDoctor/AddDoctor";
import AllUsers from "../pages/Dashboard/Allusers/AllUsers";
import ManageDoctors from "../pages/Dashboard/ManageDoctors/ManageDoctors";

import MyAppointment from "../pages/Dashboard/MyAppointment/MyAppointment";
import Payment from "../pages/Dashboard/Payment/Payment";
import Home from "../pages/Home/Home";
import Signup from "../pages/Home/Signup/Signup";
import Login from "../pages/Login/Login";
import AdminRoute from "./AdminRoute/AdminRoute";
import PrivateRoute from "./PrivateRoute/PrivateRoute";

const routes = createBrowserRouter([

    {
        path: '/', element: <Main></Main>,
        children: [
            {
                path: '/',
                element: <Home></Home>
            },
            {
                path: '/login',
                element: <Login></Login>
            },
            {
                path: '/appointment', element: <Appointment></Appointment>
            },
            {
                path: '/signup', element: <Signup></Signup>
            }
        ]
    },
    {
        path: '/dashboard', element: <PrivateRoute><DashboardLayout></DashboardLayout> </PrivateRoute>,
        children: [
            { path: '/dashboard', element: <MyAppointment></MyAppointment> },
            {
                path: '/dashboard/allusers', element: <AdminRoute> <AllUsers></AllUsers></AdminRoute>
            },
            {
                path: '/dashboard/adddoctor', element: <AdminRoute> <AddDoctor></AddDoctor></AdminRoute>
            },
            {
                path: '/dashboard/managedoctors', element: <AdminRoute> <ManageDoctors></ManageDoctors></AdminRoute>
            },
            {
                path: '/dashboard/payment/:id', element: <Payment></Payment>,
                loader: ({ params }) => fetch(`https://doctor-portal-server-theta.vercel.app/bookings/${params.id}`)
            }
        ]
    }
])

export default routes;